import React, { useEffect, useState } from "react";
import { Theme } from "@mui/system/createTheme";
import FaceTecSDK from "facetec-sdk";
import customizationFromTheme from "../logic/customizationFromTheme";

type Props = {
  children: React.ReactNode;
  // Rendered until everything is first applied.
  fallback: React.ReactNode;
  // Where the SDK loads its resources from.
  resourceDirectory: string;
  // Where the SDK loads its images from.
  imagesDirectory: string;
  theme: Theme;
};

// Applies the SDK resources, images and customization from the theme, and
// keeps them up to date.
//
// The children are only rendered once all of them are first applied, so the
// SDK initialized by them is set up from the start.
const FaceTecStaticInit: React.FC<Props> = (props) => {
  const { children, fallback, resourceDirectory, imagesDirectory, theme } =
    props;

  const [resourceDirectoryApplied, setResourceDirectoryApplied] =
    useState(false);
  const [imagesDirectoryApplied, setImagesDirectoryApplied] = useState(false);
  const [customizationApplied, setCustomizationApplied] = useState(false);

  useEffect(() => {
    FaceTecSDK.setResourceDirectory(resourceDirectory);
    setResourceDirectoryApplied(true);
  }, [resourceDirectory]);

  useEffect(() => {
    FaceTecSDK.setImagesDirectory(imagesDirectory);
    setImagesDirectoryApplied(true);
  }, [imagesDirectory]);

  useEffect(() => {
    FaceTecSDK.setCustomization(customizationFromTheme(theme));
    setCustomizationApplied(true);
  }, [theme]);

  const applied =
    resourceDirectoryApplied && imagesDirectoryApplied && customizationApplied;

  if (!applied) return <>{fallback}</>;

  return <>{children}</>;
};

export default FaceTecStaticInit;
